import React, {useContext, useEffect} from "react";
import {useLocation} from "react-router-dom";

import SapTech from "../../../assets/images/solutions/Sap.png";
import CompanyCarousel from "../../../components/carousel";
import Footer from "../../../components/footer";
import Header from "../../../components/header";
import * as S from "./styles";
import GetInTouch from "../../../components/getInTouch";
import Questions from "../../../components/questions";
import Breadcrumbs from "../../../components/breadcrumbs";
import {GlobalContext} from "../../../context/global/globalContext";

function Sap() {
  const {setBreadcrumbs} = useContext(GlobalContext);
  const location = useLocation();

  useEffect(() => {
    setBreadcrumbs([
      {label: "Home", path: "/"},
      {label: "Technologies", path: "/technologies"},
      {label: "Sap", path: "/technologies/sap"},
    ]);
  }, [location, setBreadcrumbs]);

  const questionsData = [
    {
      question: "What is your SAP product used for?",
      answer:
        "It's designed for air cleaning applications such as sulphuric acid plants or gas absorbers.",
    },
    {
      question: "Is it available in standard sizes?",
      answer: "Yes, but custom dimensions can be provided upon request.",
    },
    {
      question: "How resistant is it to corrosive gases?",
      answer:
        "Highly resistant — our materials are selected specifically for aggressive environments.",
    },
  ];

  return (
    <>
      <Header />
      <S.Container>
        <Breadcrumbs />

        <S.MainHeading>SAP Technologies</S.MainHeading>

        <S.TwoColumnSection>
          <S.Column>
            <S.Paragraph>
              Ecosystems, in partnership with MECS Elessent for North-West Europe, offers
              comprehensive equipment and services for smelter off-gas cleaning and sulphuric acid
              production. With a strong presence across Europe, Ecosystems provides cutting-edge
              technologies for reliable, low-emission, and energy-efficient acid plant operations.
            </S.Paragraph>
            <S.Paragraph>
              We supply a broad range of high-performance systems, including catalyst supplies, mist
              eliminators, acid coolers, and tailgas scrubbers. Our solutions are engineered for
              safety, energy recovery, corrosion resistance, and long-term stability, ensuring
              compliance with stringent environmental standards.
            </S.Paragraph>
          </S.Column>
          <S.ImageContainer>
            <img src={SapTech} alt="Sap Technologies" />
          </S.ImageContainer>
        </S.TwoColumnSection>

        <S.Section>
          <S.SectionTitle>How Gas Scrubbers Work</S.SectionTitle>
          <S.Paragraph>
            Ecosystems and MECS provide tailored equipment and process design solutions for new and
            revamped sulphuric acid plants. Our offering includes:
          </S.Paragraph>

          <S.List>
            <S.BulletItem color="black">
              Catalysts: Vanadium pentoxide types such as LP110, LP120, cesium-promoted SCX2000, and
              the new Gear catalyst with 30% lower pressure drop or 25–30% higher SO₂ conversion.
            </S.BulletItem>
            <S.BulletItem color="black">
              Mist Eliminators: Patented high-efficiency mist eliminators, with optional Auto Drain
              for safe maintenance and dry handling within 24 hours.
            </S.BulletItem>
            <S.BulletItem color="black">
              Uniflow Acid Distributors: Unique MECS design allowing reduced mist formation, 25%
              lower pressure drop, and adjustable during commissioning.
            </S.BulletItem>
            <S.BulletItem color="black">
              Zecor™ Equipment: Acid towers and coolers made from MECS-grade Zecor™ alloys for
              zero corrosion and consistent acid quality.
            </S.BulletItem>
            <S.BulletItem color="black">
              Tailgas Scrubbers: Available for all known process types, including H₂O₂, ammonia,
              caustic, and seawater systems.
            </S.BulletItem>
            <S.BulletItem color="black">
              Process Instrumentation: SO₃ dewpoint meters, expansion joints, acid-resistant repair
              kits to support plant safety and performance.
            </S.BulletItem>
          </S.List>
        </S.Section>

        <S.TwoColumnSection>
          <S.Column>
            <S.SectionTitle>Process Design</S.SectionTitle>
            <S.List>
              <S.BulletItem color="blue">Temperature Ranges: 0 - 600°C</S.BulletItem>
              <S.BulletItem color="blue">Flow Rates: 500 to 200,000 Nm³/h</S.BulletItem>
              <S.BulletItem color="blue">Operating Pressure: -100 to +200 mbar </S.BulletItem>
              <S.BulletItem color="blue">Pressure Drop: 10 – 200 mbar</S.BulletItem>
              <S.BulletItem color="blue">Efficiency: up to 99,9% removal efficiency</S.BulletItem>
            </S.List>
          </S.Column>
          <S.Column>
            <S.SectionTitle>Materials</S.SectionTitle>
            <S.List>
              <S.BulletItem color="blue">
                Stainless steel (316L, 304L, 904L, high-nickel alloys)
              </S.BulletItem>
              <S.BulletItem color="blue">MECS®ZeCor®, SX and Cast Iron</S.BulletItem>
              <S.BulletItem color="blue">Linings of PP or PTFE</S.BulletItem>
            </S.List>
          </S.Column>
        </S.TwoColumnSection>

        <S.QuestionsSpacing>
          <Questions items={questionsData} />
        </S.QuestionsSpacing>

        <S.ContainerTitles>
          <S.MiniTitle>Our Partners</S.MiniTitle>
          <S.Title>
            We partner with industry leaders to create clean alternatives to traditional industrial
            processes
          </S.Title>
        </S.ContainerTitles>

        <CompanyCarousel />
        <GetInTouch />
      </S.Container>
      <Footer />
    </>
  );
}

export default Sap;
